// react
import { useContext, useState } from 'react';

// types
import { financiersExt } from '../../../../../@types/unions';
import { Account, Entity, Loan } from '../../../../../@types';

// i18n
import { useTranslation } from 'react-i18next';

// context
import { ContextLoans, ContextProject } from '../../Project.context';

// mui
import { Container, Grid, Typography } from '@mui/material';

// router
import { useParams } from 'react-router-dom';

// hooks
import { useFetch } from '../../../../../hooks/useFetch';

// tables
import { TableFinancingSources } from '../../../../tables/cards/TableFinancingSources/TableFinancingSources';

// ui
import { SummaryFinancingSources } from '../../../../ui/SummaryFinancingSources/SummaryFinancingSources';

// props
export interface DetailsProps {
	hasSummary?: boolean;
}

export const Details = ({ hasSummary = false }: DetailsProps) => {
	// context
	const { loans, isLoadingLoans } = useContext(ContextLoans);
	const { isOnboarded } = useContext(ContextProject);

	// hooks
	const { t } = useTranslation();
	const { id: idWbg } = useParams();

	// state
	const [loansNotOnboarded, setLoansNotOnboarded] = useState<Loan[]>([]);

	// session
	const accessToken = sessionStorage.getItem('accessToken');
	const idToken = sessionStorage.getItem('idToken');

	// vars
	const isExt = (l: Loan) => financiersExt.some((f) => l.financier === f);
	const loansExt = loans.filter((l) => isExt(l));
	const loansWbg = loans.filter((l) => !isExt(l));

	useFetch({
		isEnabled: isOnboarded,
		url: `${process.env.REACT_APP_API_URL}/wbg?isOnboarded=true&q=${idWbg}`,
		options: {
			headers: {
				Authorization: `Bearer ${accessToken}`,
				User: String(idToken),
			},
		},
		onSuccess: (res) => {
			if (res.data?.length) {
				const project = res.data[0];
				const { accounts, entities, loans } = project;
				setLoansNotOnboarded(
					loans.map((loan: Partial<Loan>) => {
						loan.isNew = true;
						loan.accounts = accounts as Account[];
						loan.entities = entities as Entity[];
						return loan;
					})
				);
			}
		},
	});

	return (
		<Container maxWidth={false}>
			<Grid container spacing={2}>
				<Grid item xs={12}>
					<Typography variant="h2">
						{isOnboarded ? t('worldBankFinancingSources') : t('financingSources')}
					</Typography>
				</Grid>
				{hasSummary && (
					<Grid item xs={12}>
						<SummaryFinancingSources loans={loansWbg} />
					</Grid>
				)}
				<Grid item xs={12}>
					<TableFinancingSources
						hasFilters={false}
						hasSearch={false}
						isLoading={isLoadingLoans}
						loans={[...loansWbg, ...loansNotOnboarded]}
					/>
				</Grid>
				{isOnboarded && (
					<>
						<Grid item xs={12}>
							<Typography variant="h2">{t('otherFinancingSources')}</Typography>
						</Grid>
						{hasSummary && (
							<Grid item xs={12}>
								<SummaryFinancingSources loans={loansExt} />
							</Grid>
						)}
						<Grid item xs={12}>
							<TableFinancingSources
								hasFilters={false}
								hasSearch={false}
								isLoading={isLoadingLoans}
								loans={loansExt}
							/>
						</Grid>
					</>
				)}
			</Grid>
		</Container>
	);
};
